import React from 'react';
import TrackerInputShell from './TrackerInputShell';

interface NumberButtonProps {
  active?: boolean;
  last?: boolean;
  onClick(): void;
}

interface FiverInputProps {
  name: string;
  value?: FiverValue;
  callback(value: FiverValue): void;
}

const NumberButton: React.FC<NumberButtonProps> = ({ children, active, last = false, ...rest }) => (
  <button
    type="button"
    className={`f6 sans-serif round-input ${last ? 'mr0' : 'mr1'} ${
      active ? 'bg-navy white' : 'ba b--light-gray navy'
    } `}
    {...rest}
  >
    {children}
  </button>
);

const FiverInput: React.FC<FiverInputProps> = ({ name, value = null, callback }) => (
  <TrackerInputShell trackerName={name} data-testid={`input-fiver-${name}`}>
    <NumberButton data-testid="1" active={value === 1} onClick={() => callback(1)}>
      1
    </NumberButton>
    <NumberButton data-testid="2" active={value === 2} onClick={() => callback(2)}>
      2
    </NumberButton>
    <NumberButton data-testid="3" active={value === 3} onClick={() => callback(3)}>
      3
    </NumberButton>
    <NumberButton data-testid="4" active={value === 4} onClick={() => callback(4)}>
      4
    </NumberButton>
    <NumberButton data-testid="5" active={value === 5} onClick={() => callback(5)} last={true}>
      5
    </NumberButton>
  </TrackerInputShell>
);

export default FiverInput;
